module.exports = __webpack_public_path__ + "static/media/word.c7a9d107.svg";